import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MultiColumnFilterBaseComponent } from '@ups/xplat/features';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-multi-column-filter',
  templateUrl: 'multi-column-filter.component.html',
  standalone: false,
})
export class MultiColumnFilterComponent extends MultiColumnFilterBaseComponent {}
